import React, { ReactNode, createContext, useState } from 'react';


interface Product {
  editFlag: boolean;
  qualCompletedPercentage: number;
  clientid: string;
  productid: string;
  clientproductid: string;
  percentagetosale: string;
  businessName: string;
  ConsultingStatusFlag: boolean;
  LeadsStatusFlag: boolean;
  expectedclosedate: string;
  productname: string;
  account: string;
  assignTo: string;
  status: string;
  estimatedvalue: string;
  value: string;
  label: string;
}


export interface TriggerContextType {
  value: boolean;
  setValue: (newValue: boolean) => void;
  triggerLeadDetails:boolean;
  setTriggerLeadDetails:(trigger:boolean)=>void;
  productDetails:Product|null;
  setProductDetails:(productsDetails:Product) => void;
  readOnlyMode:boolean;
  setReadOnlyMode:(data:boolean)=>void;
}

interface TriggerContextProviderProps {
  children: ReactNode;
}

export const TriggerContext = createContext<TriggerContextType | undefined>(undefined);

export const TriggerContextProvider: React.FC<TriggerContextProviderProps> = ({ children }) => {
  const [value, setValue] = useState<boolean>(false);
  const [triggerLeadDetails, setTriggerLeadDetails] = useState<boolean>(false);
  const [productDetails, setProductDetails] = useState<Product|null>(null);
  const [readOnlyMode,setReadOnlyMode] = useState<boolean>(false);

  const contextValue: TriggerContextType = {
    value,
    setValue,
    triggerLeadDetails,
    setTriggerLeadDetails,
    productDetails,
    setProductDetails,
    readOnlyMode,
    setReadOnlyMode
  };

  return <TriggerContext.Provider value={contextValue}>{children}</TriggerContext.Provider>;
}